import React from 'react'
import PropTypes from 'prop-types'
import bindCx from 'classnames/bind'
import css from './styles.css'

const cx = bindCx.bind(css)

const GroupsMenuItem = ({ item, onClick, isSelected, type }) => (
  <li
    className={cx({ selectedListItem: isSelected, listItem: !isSelected })}
    key={item.id}
    onClick={() => { onClick(item.id, type, 'list') }}
  >
    {item.name}
  </li>
)

GroupsMenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string, // for appt-based patient filters
      PropTypes.number, // when it's a "custom group"
    ]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
}

export default GroupsMenuItem



// WEBPACK FOOTER //
// ./src/components/PatientGroups/GroupsMenu/Item.js